exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clearcart-btn[data-v-35bb906e]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}@media (max-width: 767px){.clearcart[data-v-35bb906e]{font-size:14px}}\n", ""]);

// exports
